// JsFromRoutes CacheKey 38b9522ddc22dfc4590ffbc09708d960
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/account_types'),
}
